module.exports = __webpack_public_path__ + "components/panel/ski-bro/static/swiss-ca6a77f78e8b695bf268f6796bf87168.webp";